import { OuiButton } from 'omnium-ui/button';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { AuthService } from '@lib/services/auth-service.service';

@Component({
  selector: 'app-migration-error-page',
  imports: [OuiButton],
  templateUrl: './migration-error-page.component.html',
  styleUrl: './migration-error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MigrationErrorPageComponent {
  private readonly authService = inject(AuthService);
  private readonly environment = inject<any>('environment' as any);

  redirectToAriane() {
    window.location.assign(this.environment.arianeFicheBaseUrl);
  }

  logout() {
    this.authService.logout();
  }
}
